module.exports = __webpack_public_path__ + "img/play-store-badge.278119e5.png";